/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum UserPrebidAlertState {
  Normal = 'normal',
  Firing = 'firing',
  Suppressed = 'suppressed'
}
